import { VFC, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Q_MIN_VALUES, Qmin } from '@enmon/commons';
import { Select } from '../../Select';
import { MeterDetails as messages } from '../../../Form/meter_details/messages';
import { useMeterModelSuggestionsStore } from '../../../../store/useMeterModelSuggestionsStore';
import { getSelectOptionsWithSuggestions } from '../../utils/getSelectOptionsWithSuggestions';

interface QMinProps {
  value?: Qmin;
  onChange?: (value: Qmin) => void;
}

export const QMinSelect: VFC<QMinProps> = ({ ...restProps }) => {
  const intl = useIntl();
  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  const qMinOptions = useMemo(
    () =>
      getSelectOptionsWithSuggestions({
        intl,
        values: Q_MIN_VALUES,
        suggestedValue: meterModelSuggestions?.qMin?.value,
        suggestedSelection: meterModelSuggestions?.qMin?.selection,
      }),
    [intl, meterModelSuggestions],
  );

  return (
    <Select
      allowClear
      showArrow
      className="w-100"
      options={qMinOptions}
      placeholder={<FormattedMessage {...messages.qMinPlaceholder} />}
      suffix={`m${String.fromCharCode(179)}/h`}
      {...restProps}
    />
  );
};
